export default __webpack_public_path__ + "static/media/forward.4123e3fb.svg";